export default "__VITE_ASSET__l05DMlZ7__"